/**
 * OpenAPI / backend `FieldDefinition.dataType` values for numeric columns.
 * Legacy payloads used `"number"`; new writes use {@link API_NUMBER_DATA_TYPES}.
 */
export const API_NUMBER_DATA_TYPES = {
	Integer: "integer",
	Decimal: "decimal",
} as const;

export type ApiNumberDataType =
	(typeof API_NUMBER_DATA_TYPES)[keyof typeof API_NUMBER_DATA_TYPES];

/**
 * Maps API or legacy `dataType` strings to a supported API number kind.
 */
export function normalizeApiNumberDataType(
	dataType: string,
): ApiNumberDataType {
	const key = dataType.trim().toLowerCase();
	if (key === "integer") return API_NUMBER_DATA_TYPES.Integer;
	if (key === "decimal") return API_NUMBER_DATA_TYPES.Decimal;
	return API_NUMBER_DATA_TYPES.Decimal;
}
